module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-43.634aac17.png";